<div>
  <app-contributors-list [enableRemoveContributor]="false" [contributors]="contributors"> </app-contributors-list>
  <div class="updateCancelButtons" *ngIf="!isReadOnly">
    <button mat-button color="primary" (click)="switchToEdit.emit()">
      CHANGE
    </button>
  </div>
</div>
